import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcRsvdAccuApi = async (
    gameSvcCd:string|null,
) => {
    return await CommApiInstance.post(`memb/${gameSvcCd}/rsvd/account`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default GameSvcRsvdAccuApi;